<template>
  <article :class="$style.item">
    <div :class="$style.image">
      <img v-if="imageUrl" :src="imageUrl" :alt="reward.resource?.name" />
    </div>
    <p :class="$style.percent">
      {{ t('top', { percent: reward.top_percent }) }}
    </p>
  </article>
</template>

<i18n>
{
  "ru": {
    "top": "В Топ {percent}%"
  }
}
</i18n>

<script setup lang="ts">
import type { FantasyReward } from '~/types/fantasy'

const props = defineProps<{
  reward: FantasyReward
}>()

const { t } = useI18n()

const imageUrl = computed(() => props.reward.resource?.image_url?.small)
</script>

<style lang="scss" module>
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 8.2em;
  padding: 0.8em;
  gap: 0.4em;
  border-radius: 1.2em;
  background: color-get(--root-rgb-bg-card);

  @include down(md) {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
}

.image {
  flex-shrink: 0;
  width: 5em;
  height: 4.2em;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.percent {
  margin: 0;
  @include typo-get(body-xs);
  color: color-get(--root-rgb-text-2);
  text-align: center;
}
</style>
